module.exports = __webpack_public_path__ + "static/media/after_login_bg.32125557.jpg";